export default "__VITE_ASSET__DeBIUM_6__"